<template>
  <div
    data-qa="lpu_page_vrachi"
    class="lpu-branding"
    :style="colorVarStyles"
  >
    <HeroSectionDesktop
      v-if="!isMobile"
      :lpu="context.lpu"
      :lpu-branding="context.lpu_branding"
      :lpu-video-card="context.lpu_video_card"
    />
    <CoreSnackbar />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import useContextStore from 'src/store/useContextStore'
import CoreSnackbar from 'src/core/CoreSnackbar/CoreSnackbar.vue'
import HeroSectionDesktop from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/HeroSectionDesktop.vue'
import type { ContextStore } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/vrachi/types'
import useBrandingColors from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_composables/useBrandingColors'

const { context }: ContextStore = useContextStore()

const isMobile = useIsMobile()

const { colorVarStyles } = useBrandingColors(computed(() => context.lpu_branding))
</script>

<style lang="scss">
@import 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_styles/colors';
@import 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_styles/rounded';
@import 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_styles/branding-btn';
</style>
